<template>
  <div>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
      <div class="modal-header justify-content-center" style="padding: 0px">
        <h5 class="text-center" style="padding: 0px">{{ empresaNome }}</h5>
      </div>
      <b-card no-body>
        <b-card-body>
          <b-card bg-variant="light">
            <b-form @submit.prevent="load">
              <b-row>
                <b-col>
                  <lg-form-const-select @change="load()" v-model="situacao" id="situacao"
                    :options="optionsFilterSituacao" label="Situação:" />
                </b-col>

                <b-col>
                  <lg-form-input id="searchText" label="Descrição:" v-model="searchText" />
                </b-col>
                <b-col class="ml-4 d-flex align-items-center">
                  <b-button id="procurar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                    @click="load">
                    <div class="btn-size-alinhamento">
                      <b-icon icon="search" />
                    </div>
                    <b-tooltip target="procurar" title="Localizar" triggers="hover focus"></b-tooltip>
                  </b-button>
                </b-col>
                <b-col class="text-right d-flex justify-content-end align-items-center">
                  <b-button v-if="temPrivilegioCadastro()" id="novo" class="ml-3 mr-2 my-2" style="height: 20px" size="sm" pill variant="secondary"
                    @click="showModalAdicionar = true">
                    <div class="btn-size-alinhamento">
                      <b-icon scale="1" icon="plus" />
                    </div>
                    <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
          <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.fields"
              :hover="true" show-empty>
              <template #empty>
                <p>Nenhum registro encontrado</p>
              </template>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>


              <template #cell(endereco)="{ item }">
                <span class="px-2"><strong>Tipo de endereço:</strong>
                  {{ item.tipoEndereco.descricao }}</span>
              </template>
              <template #cell(acoes)="{ item }">
                <div class="d-flex align-items-center justify-content-end">
                  <b-button :disabled="!temPrivilegioEdicao()" id="modificar" class="my-2" size="sm" pill variant="primary" @click="ModalEditar(item)">
                    <b-icon icon="pencil-square" />
                    <b-tooltip target="modificar" title="Editar..." triggers="hover"></b-tooltip>
                  </b-button>


                  <span class="mx-2">
                    <b-button v-if="item.enderecoPrincipal" variant="success" class="my-2 mx-2" size="sm"
                      :id="'endereco-principal-icon-' + item.id">
                      <b-icon icon="check-circle" />
                      <b-tooltip :target="'endereco-principal-icon-' + item.id" title="Endereço principal"
                      triggers="hover"></b-tooltip>

                    </b-button>
                  </span>

                  <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch
                    size="lg" :value="1" :unchecked-value="0" class="text-right" :id="'situacao-' + item.id" />
                  <b-tooltip :target="'situacao-' + item.id" title="Alterar situação" triggers="hover"
                    class="text-right"></b-tooltip>
                </div>
              </template>
            </b-table>
            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
              <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                Página {{ page }} de {{ totalPage }} - {{ total }} registros
              </b-col>
              <b-col cols="6">
                <div class="d-flex justify-content-end align-items-end">
                  <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                    :total-rows="total"></b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-card-body>
      </b-card>
      <ModalEnderecosAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
        @fechar="fechar" :id="idEdit"></ModalEnderecosAdicionar>
    </b-modal>
  </div>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ModalEnderecosAdicionar from "./ModalEnderecosAdicionar.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ModalEnderecosAdicionar,
  },
  props: {
    id: Number,
    prefix: Array,
    empresaNome: String,
    codEmpresa: Number,
  },
  data() {
    return {
      showModal: true,
      situacao: 1,
      searchText: "",
      showModalAdicionar: false,
      idEdit: null,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/endereco`);
  },
  mounted() {
    this.load();
  },
  computed: {
    fields() {
      return [
        { key: "endereco", label: "" },
        { key: "acoes", label: "", tdClass: "text-right" },
      ];
    },
    updatedPrefix() {
      return [...this.prefix, "Endereço"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

    },


    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Endereço?",
        item.logradouro
      )
      if (response) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },
    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);

      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        });
      }
    },
    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    async load() {
      this.busy = true;
      var filtro = {};
      if (this.codEmpresa) {
        filtro.codEmpresa = this.codEmpresa;
      }
      if (this.searchText) {
        filtro.pesquisaEndereco = this.searchText;
      }
      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });
    },
    fechar() {
      this.showModalAdicionar = false;
      this.idEdit = null;
      this.load();
    },
    cancelar() {
      this.$emit("close");
    },
  },
};
</script>
